import { animated, config, useTransition } from '@react-spring/web';
import type { ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  isolation: isolate;
  & > * {
    position: absolute;
    top: 0;
    white-space: nowrap;
    &:nth-child(1) {
      position: unset;
    }
  }
`;

type Props = {
  children: ReactNode;
  trigger: string | number | boolean;
  delay?: number;
};

export const Impact = ({ children, trigger, delay = 0 }: Props) => {
  const transitions = useTransition(trigger, {
    initial: null,
    from: {
      opacity: 0,
      transform: 'scale(0.5)',
    },
    enter: {
      opacity: 1,
      transform: 'scale(1)',
    },
    config: config.wobbly,
    delay,
  });

  return (
    <Wrapper>
      {transitions((style, item) => (
        <animated.div style={style} key={item?.toString()}>
          {children}
        </animated.div>
      ))}
    </Wrapper>
  );
};
